import React from 'react'
import Navbar from './containers/Navbar'

const Topbar = () => {
  return (
    <Navbar />
  )
}

export default Topbar
